<template>
  <div>
    <template v-if="usersCount > 0">
      <div class="divider-text">Ажиллаж буй</div>
      <div style="overflow-y: auto">
        <table class="table-god table table-bordered w-full">
          <thead style="font-size: 10px">
            <tr>
              <th style="width: 40px">№</th>
              <th>Хэрэглэгч</th>
              <template
                v-if="
                  objectTypeId == 361 && $store.state.app.activeGroup.id == 9379
                "
              >
                <th style="width: 40px">Эхлэх</th>
                <th style="width: 40px">Дуусах</th>
                <th style="width: 40px">Засах</th>
              </template>
              <template v-else>
                <th>%</th>
                <th style="width: 40px">үзсэн</th>
                <th style="width: 40px">дууссан</th>
                <th style="width: 40px">
                  <i
                    title="Хэрэглэгчид чатаар хавсралт болгож илгээх"
                    class="ivu-icon ivu-icon-ios-chatbubbles"
                    style="font-size: 16px; color: rgb(132, 132, 132);"
                  ></i>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(u, i) in users" :key="`unpinned_` + u.taskId">
              <td>{{ i + 1 }}</td>
              <td style="min-width: 100px">
                <a role="button" @click="handleUserInfoModal(u.taskId)">
                  {{ u.displayName }}</a
                >
              </td>
              <template
                v-if="
                  objectTypeId == 361 && $store.state.app.activeGroup.id == 9379
                "
              >
                <td class="text-center">
                  {{ u.courseFvwDate | moment("YYYY.MM.DD") }}
                </td>
                <td class="text-center">
                  {{ u.courseCmpDate | moment("YYYY.MM.DD") }}
                </td>
                <td class="text-center">
                  <a
                    role="button"
                    @click="
                      updateDateModal.user = u;
                      updateDateModal.show = true;
                    "
                    ><feather type="edit"></feather
                  ></a>
                </td>
              </template>
              <template v-else>
                <td class="text-center">{{ u.perc }}</td>
                <td class="text-center"></td>
                <td class="text-center"></td>
              </template>
            </tr>
          </tbody>
        </table>
        <b-pagination
          class="mg-l-auto"
          size="sm"
          align="right"
          v-model="pagerPinned.current"
          :total-rows="usersCount"
          :per-page="pagerPinned.perPage"
          @change="pagePinnedChanged"
          style="margin-bottom: 0"
        ></b-pagination>
      </div>
    </template>

    <template>
      <div class="divider-text">Бусад оролцогчид</div>
      <div class="text-center">
        <div class="d-flex pd-y-5 align-items-center mg-l-10">
          <div class="input-group">
            <input
              v-model="searchByName"
              type="text"
              placeholder="Нэрээр хайх"
              class="form-control"
              style="width: auto;"
            />
            <div class="input-group-append">
              <button
                @click="
                  pagerUnpinned.current = 1;
                  getOtherList();
                "
                class="btn btn-icon btn-outline-light btn-xs"
              >
                <feather type="search"></feather>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style="overflow-y: auto">
        <table class="table-god table table-bordered w-full">
          <thead style="font-size: 10px">
            <tr>
              <th style="width: 40px">№</th>
              <th>Хэрэглэгч</th>

              <template
                v-if="
                  objectTypeId == 361 && $store.state.app.activeGroup.id == 9379
                "
              >
                <th style="width: 40px">Эхлэх</th>
                <th style="width: 40px">Дуусах</th>
                <th style="width: 40px">Засах</th>
              </template>
              <template v-else>
                <th>%</th>
                <th style="width: 40px">үзсэн</th>
                <th style="width: 40px">дууссан</th>
                <th style="width: 40px">
                  <i
                    title="Хэрэглэгчид чатаар хавсралт болгож илгээх"
                    class="ivu-icon ivu-icon-ios-chatbubbles"
                    style="font-size: 16px; color: rgb(132, 132, 132);"
                  ></i>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(u, i) in usersOR" :key="`unpinned_` + u.taskId">
              <td>{{ i + 1 }}</td>
              <td style="min-width: 100px">
                <a role="button" @click="handleUserInfoModal(u.taskId)">
                  {{ u.displayName }}</a
                >
              </td>
              <template
                v-if="
                  objectTypeId == 361 && $store.state.app.activeGroup.id == 9379
                "
              >
                <td class="text-center">
                  {{ u.courseFvwDate | moment("YYYY.MM.DD") }}
                </td>
                <td class="text-center">
                  {{ u.courseCmpDate | moment("YYYY.MM.DD") }}
                </td>
                <td class="text-center">
                  <a
                    role="button"
                    @click="
                      updateDateModal.user = u;
                      updateDateModal.show = true;
                    "
                    ><feather type="edit"></feather
                  ></a>
                </td>
              </template>
              <template v-else>
                <td class="text-center">{{ u.perc }}</td>
                <td class="text-center"></td>
                <td class="text-center"></td>
              </template>
            </tr>
          </tbody>
        </table>
        <b-pagination
          class="mg-l-auto"
          size="sm"
          align="right"
          v-model="pagerUnpinned.current"
          :total-rows="usersCountOR"
          :per-page="pagerUnpinned.perPage"
          @change="pageUnpinnedChanged"
          style="margin-bottom: 0"
        ></b-pagination>
      </div>
    </template>

    <b-modal v-model="updateDateModal.show" title="Лицензийн хугацаа засах">
      <Form label-position="top" label-width="100%">
        <FormItem label="Хэрэглэгчийн мэдээлэл">
          <Alert
            type="info"
            :title="updateDateModal.user.displayName"
            :description="updateDateModal.user.userName"
            :closable="false"
          ></Alert>
        </FormItem>
        <FormItem label="Лицензийн мэдээлэл">
          <Select v-model="updateDateModal.user.i1" style="width: 100%">
            <Option :value="10" label="Мэргэшсэн"> </Option>
            <Option :value="20" label="Мэргэшсэн эхний сунгалт"> </Option>
            <Option :value="30" label="Мэргэшсэн 2 дах сунгалт"> </Option>
            <Option :value="40" label="Зөвлөх"> </Option>
            <Option :value="50" label="Зөвлөх эхний сунгалт"> </Option>
            <Option :value="60" label="Зөвлөх 2 дах сунгалт"> </Option>
          </Select>
        </FormItem>
        <FormItem label="Эхлэх огноо">
          <DatePicker
            v-model="updateDateModal.user.courseFvwDate"
            placeholder="Огноо сонгоно уу"
            type="date"
            style="width: 100%"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
          ></DatePicker>
        </FormItem>
        <FormItem label="Дуусах огноо">
          <DatePicker
            v-model="updateDateModal.user.courseCmpDate"
            placeholder="Огноо сонгоно уу"
            type="date"
            style="width: 100%"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
          ></DatePicker>
        </FormItem>
      </Form>

      <template #modal-footer>
        <div class="mg-l-auto btn-group">
          <button
            @click="updateDateModal.show = false"
            type="button"
            class="btn btn-danger btn-xs btn-uppercase"
          >
            Хаах
          </button>
          <button
            @click="saveDataPrompt()"
            type="button"
            class="btn btn-primary btn-xs btn-uppercase"
          >
            Хадгалах
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { request } from "@/api/all";
import {
  DatePicker,
  Form,
  FormItem,
  Alert,
  MessageBox,
  Message,
  Select,
  Option,
} from "element-ui";
const moment = require("moment");

export default {
  components: {
    DatePicker,
    Form,
    FormItem,
    Alert,
    MessageBox,
    Message,
    Select,
    Option,
  },

  name: "taskShare",
  props: {
    objectTypeId: {
      type: Number,
      default: () => 0,
    },
    taskId: {
      type: Number,
      default: () => 0,
    },
    drwrW: {
      type: String,
      default: () => "30vw",
    },
  },
  data() {
    return {
      searchByName: "",
      pagerPinned: {
        perPage: 10,
        current: 1,
      },
      pagerUnpinned: {
        perPage: 10,
        current: 1,
      },
      updateDateModal: {
        user: {},
        show: false,
      },
      users: [],
      usersOR: [],
      usersCount: 0,
      usersCountOR: 0,
    };
  },
  mounted() {
    this.init();
    this.getOtherList();
  },
  methods: {
    ...mapActions(["handleUserInfoModal"]),
    init() {
      //getPinnedList({ id: this.taskId, page: this.pageCur, size: this.pageSize }).

      request({
        api: { method: "get", url: "TaskInUser/GetPinnedList" },
        params: {
          taskId: this.taskId,
          page: this.pagerPinned.current - 1,
          size: this.pagerPinned.perPage,
        },
        store: this.$store,
      }).then((res) => {
        this.users = res.data.users;
        this.usersCount = res.data.count;
        //this.ready= true;
      });
    },
    saveDataPrompt() {
      MessageBox.confirm(
        `Та ${
          this.updateDateModal.user.displayName
        } хэрэглэгчийн лицензийн хугацааг ${moment(
          this.updateDateModal.user.courseFvwDate
        ).format("YYYY.MM.DD")} - ${moment(
          this.updateDateModal.user.courseCmpDate
        ).format("YYYY.MM.DD")} болгож өөрчлөх гэж байна 
        баталгаажуулах уу?`,
        "Санамж",
        {
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          type: "warning",
        }
      )
        .then(() => {
          this.saveData();
          //this.trainingBatlah();
        })
        .catch(() => {
          console.log("Батлагдсангүй");
        });
    },
    saveData() {
      //alert("save req call")
      request({
        api: {
          method: "post",
          url: "TaskInUser/SaveCourseStartAndCompleteDate",
        },
        data: {
          taskId: this.taskId,
          userTaskId: this.updateDateModal.user.taskId,
          startDate: this.updateDateModal.user.courseFvwDate,
          endDate: this.updateDateModal.user.courseCmpDate,
          i1: this.updateDateModal.user.i1,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.updateDateModal.show = false;
          Message({
            message: "Амжилттай хадгаллаа.",
            type: "success",
          });
        }
      });
    },
    getOtherList() {
      //getUnPinnedList({ id: this.taskId, page: this.pageCurOR, size: this.pageSizeOR })
      request({
        api: { method: "get", url: "TaskInUser/GetUnPinnedList" },
        params: {
          taskId: this.taskId,
          page: this.pagerUnpinned.current - 1,
          size: this.pagerUnpinned.perPage,
          firstName: this.searchByName,
        },
        store: this.$store,
      }).then((res) => {
        this.usersOR = res.data.users;
        this.usersCountOR = res.data.count;
        //this.ready= true;
      });
    },
    pagePinnedChanged(e) {
      this.pagerPinned.current = e;
      this.init();
    },
    pageUnpinnedChanged(e) {
      this.pagerUnpinned.current = e;
      this.getOtherList();
    },
    // sendTask(taskId, u){
    //   this.$Message.success(u.displayName+' -т амжилттай илгээлээ');

    //    this.$store.state.osrCon
    //       .invoke("sendMessageTo", u.userName.toLowerCase(), '', 2, taskId)
    //       .catch(err => console.error(err.toString()));
    // }
  },
};
</script>
